import React from "react";
import {
  options_approval_new,
} from "../Apollo_styles";

// import Select from "react-select";
import Select from '@material-ui/core/Select';

import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import {useForm} from "react-hook-form";

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from "@material-ui/core/Typography";
// import {useForm} from "react-hook-form";


export type PropsSelectApproval = {
  defaultValue: number  // 初期選択値
  value: number         // 選択値
  setValue: any         // 選択値セット関数
  isDisabled: boolean   // 不活化
  required: boolean     // 必須
}

interface SelectApprovalProps {
  propsSelect: PropsSelectApproval
};

// 認証選択セレクトボックス表示
export default function ApolloSelectApproval(props: SelectApprovalProps) {

  const {
    defaultValue,
    value,
    setValue,
    isDisabled,
    required,
  } = props.propsSelect;

  const {errors,} = useForm();

  if (!value) {
    setValue(defaultValue);
  }

  const handleChangeApproval = (event: any) => {
    setValue(event.target.value);
  };

  return (
    <div>
      <InputLabel id="approval">
        <Typography variant="caption">
        承認状況 *
        </Typography>
      </InputLabel>
      <FormControl error={errors.approval ? true : false} fullWidth>
        <Select
          labelId="approval"
          id="approval"
          name="approval"
          key={value ? "Loaded" : "Loading"}
          value={value}
          onChange={handleChangeApproval}
          disabled={isDisabled}
          required={required}
        >
          {
            options_approval_new.map((approval: any, index: any) =>
              <MenuItem value={approval.value}>{approval.label}</MenuItem>
            )
          }
        </Select>
        <FormHelperText>{errors.approval && errors.approval.message}</FormHelperText>
      </FormControl>
    </div>
  )
}
